import React from 'react'
import SavingImg1 from '../../Images/SavingImg/PratifalSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const PratifalSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>प्रतिफल बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>सदस्यहरूले संस्थाबाट प्राप्त गर्ने सेयर लाभासं, संरक्षित पूँजी फिर्ताकोष रकम, बैठक भत्ता, सदस्यले प्राप्त गर्ने विभिन्न राहत सुविधाको रकम, पदाधिकारी भत्ता तथा आवधिक बचतको ब्याज रकम जम्मा गर्ने ।</li>
                                        <li>यस बचत खातामा रहेको रकम वा सेयर थप तथा अन्य बचत खातामा स्थानान्तरण गर्न सकिने ।</li>
                                        <li>न्युनतम मौज्दात रु १००।– राखि बचत फिर्ता गर्न सकिने ।</li>
                                        <li>संस्थाले सम्पूर्ण सदस्यहरूको निशुल्क खाता खोलिदिने ।</li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default PratifalSaving